module.exports = __webpack_public_path__ + "files/96ca8796fb6fb7458f836249d0349f27.png";